// import React from 'react';
// import PageHeader from './PageHeader';

// const Policies = () => {
//   return (
//     <>
//       <div className="heading-div">
//         <PageHeader
//           title={`Policies`}
//         />
//       </div>
//       <div className="contentWrapper"></div>
//     </>
//   );
// };

// export default Policies;

import React, { useState } from "react";
import PageHeader from "./PageHeader";
import { Tabs } from "antd";
import { items } from "./Auth/InfoNPolicies";

const Policies = () => {
  const [selectedTab, setSelectedTab] = useState(items[0].key);

  const handleChangeTab = (key) => {
    setSelectedTab(key);
  };

  return (
    <>
      <div className="heading-div">
        <PageHeader title={`Policies`} />
      </div>
      <div className="analytics-nav policies">
        <Tabs
          defaultActiveKey="0"
          activeKey={selectedTab}
          onChange={handleChangeTab}
          className="tabs tabs-custom"
        >
          {items.map((ele) => (
            <Tabs.TabPane tab={ele.label} key={ele.key}>
              {/* {ele.children} */}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
      <div className="contentWrapper policies_css">
        <Tabs
          defaultActiveKey="1"
          activeKey={selectedTab}
          onChange={handleChangeTab}
          className="tabs tabs-custom"
        >
          {items.map((ele) => (
            <Tabs.TabPane tab={""} key={ele.key}>
              {ele.children}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
    </>
  );
};

export default Policies;
